import * as Scrivito from "scrivito"
import { ScrivitoAttributes } from "shared/types/ScrivitoAttributes"

export const PimDataObjClass = Scrivito.provideObjClass("PimData", {
  attributes: {
    showInNavigation: "boolean",
    body: ["widgetlist", { only: "PimContentWidget" }],
    productType: "string",
    parentProductType: "string",
    parentExternalId: "string",
    externalId: "string",
    technicalDocumentation: ["referencelist", { only: "Download" }],
    productImages: ["referencelist", { only: "Image" }]
  },
  extractTextAttributes: ["productType", "parentProductType", "body"]
})
export type PimDataObj = InstanceType<typeof PimDataObjClass>
export type PimDataAttributes = ScrivitoAttributes<PimDataObj>
